import React, {
  Fragment as _,
  memo,
  useRef,
  useEffect,
  useContext,
} from 'react';
import EditableText from 'components/lib/EditableText';
import Carousel from './Carousel';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Image from 'components/lib/Image';
import { interactionContext } from './interactionContext';
import Container from 'components/Layouts/ContainerLogical';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import CarouselSlide from './CarouselSlide';
import IELayout from 'components/Layouts/IELayout';
import shouldUpdate from 'services/shouldUpdate';
import SVG from 'components/lib/SVG';
import Carousel_default from 'assets/Wide Image.png';
//Carousel_Placeholder.png';
import imageSVGAnimationWide from 'assets/animations/wideShotLaptopWoman.js';
import imageSVGAnimationNarrow from 'assets/animations/laptopDude.js';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  Carousel,
  Slide: CarouselSlide,
  // Image,
  Image: ({ children, ...props }) => {
    const interactionContext_ = useContext(interactionContext);
    const interactionLayout = useRef('TwoColumns');

    useEffect(() => {
      interactionLayout.current = interactionContext_.meta.layout;
    }, []);

    const updatedProps = {
      ...props,
    };

    if (!props.src) {
      updatedProps.placeholder = Carousel_default;
    }

    return <Image {...{ ...updatedProps, usePlaceholderValue: true }} />;

    if (!props.src) {
      const updatedProps = {
        ...props,
        src: JSON.stringify(
          interactionLayout.current.includes('One')
            ? imageSVGAnimationWide
            : imageSVGAnimationNarrow
        ),
      };

      return <SVG {...updatedProps} />;
    }

    return <Image {...props} />;
  },
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  ...IELayout(interactionContext),
};

const CarouselDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);
  //
  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default CarouselDisplay;
